<template>
  <div class="zwx-verify-code" :style="divStyle">
    <img class="verify-img" :style="imgStyle" :src="imgCodePath" alt="" @click="imgCodeReload()" />
  </div>
</template>

<script>
export default {
  name: 'ZwxVerifyCode',
  props: {
    width: { type: Number, default: 120 },
    height: { type: Number, default: 50 },
    imgWidth: { type: Number, default: 120 },
    imgHeight: { type: Number, default: 50 },
  },
  data() {
    return {
      api: this.$store.state.api,
      uid: this.$system.uuid(),
    }
  },
  created() {},
  mounted() {},
  computed: {
    divStyle() {
      return 'width: ' + this.width + 'px !important; height: ' + this.height + 'px !important;'
    },
    imgStyle() {
      return 'width: ' + this.imgWidth + 'px !important; height: ' + this.imgHeight + 'px !important;'
    },
    imgCodePath() {
      return this.api + '/curr/imgVerifyCode-0?uid=' + this.uid + '&ms=' + Date.now()
    },
  },
  methods: {
    imgCodeReload() {
      this.uid = this.$system.uuid()
    },
    getUid() {
      return this.uid
    },
  },
}
</script>

<style lang="less" scoped>
.zwx-verify-code {
  display: flex !important;
  align-items: center !important;
}

.verify-img {
  margin: 0 auto !important;
}
</style>

<style lang="less"></style>
